import React, { Fragment, SetStateAction } from "react";

import "./TabSlider.scss";

export type TabSliderProps = {
  cx?: string;
  name: string;
  handleSetData: React.Dispatch<SetStateAction<any>>;
  defaultChecked?: number;
  list: { value: string; text: string }[];
};

export const TabSlider: React.FC<TabSliderProps> = ({
  cx = "",
  name,
  list,
  handleSetData,
  defaultChecked = 0,
  ...props
}) => {
  return (
    <div className={`TabSlider ${cx}`} {...props}>
      {list.map(({ value, text }, idx) => (
        <Fragment key={`slider-${value}-${idx}`}>
          <input
            type={"radio"}
            name={name}
            id={"radio-" + idx}
            onChange={(e) => {
              if (e.target.checked) {
                handleSetData(value);
              }
            }}
            defaultChecked={idx === defaultChecked}
          />
          <label className={"radio-wrapper"} htmlFor={"radio-" + idx}>
            {text ?? value}
          </label>
        </Fragment>
      ))}
      <div className="glider" />
    </div>
  );
};
